import axios from "axios";

export default function PurchaseorderRequestItemsRemoveService(formData, orderId) {
  return axios({
    method: 'DELETE',
    url: process.env.REACT_APP_API_HOST + "/purchase_order/" + orderId + "/items",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
